export class ClientConfig {
  static timeout: number = 20 * 1000; // in ms
  static timeoutLargeRequest: number = 60 * 1000; // in ms
  static uploadTimeout: number = 60 * 1000; // in ms
  static ttl: number = 60 * 10 * 1000; // in ms
  static pollingFrequency = 3 * 1000; // in ms

  static maxDocumentSize = 30 * 1024 * 1024;
  static maxImageSize = 10 * 1024 * 1024;
}
